import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { HiMagnifyingGlass, HiOutlineArrowUpTray } from "react-icons/hi2";
import { useNavigate } from "react-router-dom";
import { fixMonthDisplay } from "../../../Utils/utilServices";

const formatDateInput = (date) => date.toISOString().split("T")[0];

const columns = [
  { field: "orderId", header: "Order ID" },
  { field: "txnId", header: "Txn Id" },
  { field: "patientName", header: "Patient Name" },
  { field: "patientId", header: "Patient ID" },
  { field: "patientMobile", header: "Patient Mobile" },
  { field: "patientAddress", header: "Patient Address" },
  { field: "billingName", header: "Billing Eclinic Name" },
  { field: "billingAddress", header: "Billing Eclinic Address" },
  { field: "billingContactNumber", header: "Billing Eclinic Contact No" },
  { field: "shipTo", header: "Ship To" },
  { field: "shippingPartnerName", header: "Shipping Name" },
  { field: "shippingAddress", header: "Shipping Address" },
  { field: "shippingContactNumber", header: "Shipping Contact No" },
  { field: "productCode", header: "Product Code" },
  { field: "drugName", header: "Product Name" },
  { field: "category", header: "Category" },
  { field: "frameType", header: "Frame Type" },
  { field: "quantity", header: "Quantity" },
  { field: "unitPrice", header: "Unit Price (INR)" },
  { field: "totalAmount", header: "Total Amount (INR)" },
  { field: "finalAmount", header: "Final Amount (INR)" },
  { field: "paymentStatus", header: "Payment Status" },
  { field: "paymentMode", header: "Payment Mode" },
  { field: "billingDate", header: "Billing Date & Time" },
  { field: "type", header: "Type Of Order" },
];

const stateList = [
  { name: "Odisha", value: "OD" },
  { name: "Chhattisgarh", value: "CG" },
  { name: "Jharkhand", value: "JH" },
];

const EyewearOrderReports = () => {
  const navigate = useNavigate();
  const today = new Date();
  const twoDaysAgo = new Date();
  twoDaysAgo.setDate(today.getDate() - 2);

  const user = JSON.parse(localStorage.getItem("loginObj"));
  const [loggedInUser] = useState(
    user?.userRolesList?.find(
      (u) => u.roleCode === "PHHEAD" || u.roleCode === "PH",
    ),
  );

  const [tableData, setTableData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [defaultWHList, setdefaultWHList] = useState([]);
  const [warehouseList, setwarehouseList] = useState([]);

  const [filters, setFilters] = useState({
    reportType: "EYEWEAR",
    state:
      loggedInUser?.roleCode !== "PHHEAD"
        ? localStorage.getItem("userState")
        : "OD",
    fromDate: formatDateInput(twoDaysAgo),
    toDate: formatDateInput(today),
    orderId: "",
    patientId: "",
    circleCode: localStorage.getItem("circleCode")
      ? [localStorage.getItem("circleCode")]
      : ["N"],
  });

  const baseUrl = process.env.REACT_APP_API_BASE_URL;

  const [warehouseDropdownOpen, setWarehouseDropdownOpen] = useState(false);
  const warehouseDropdownRef = useRef(null);

  const formatDate = (date) => {
    const d = new Date(date);
    return `${String(d.getMonth() + 1).padStart(2, "0")}/${String(
      d.getDate(),
    ).padStart(2, "0")}/${d.getFullYear()}`;
  };

  const wareHouseData = async () => {
    try {
      const response = await axios.get(`${baseUrl}warehouse/list`);
      const res = response.data.successList;
      setdefaultWHList(res);
      setwarehouseList(res.filter((e) => e.stateCode == filters.state));
    } catch (err) {
      console.error("Error fetching warehouse details:", err);
    }
  };

  useEffect(() => {
    setwarehouseList(defaultWHList.filter((e) => e.stateCode == filters.state));
  }, [filters.state, defaultWHList]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        warehouseDropdownRef.current &&
        !warehouseDropdownRef.current.contains(event.target)
      ) {
        setWarehouseDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    wareHouseData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchData = async (overrideFilters) => {
    const activeFilters = overrideFilters || filters;
    setIsLoading(true);
    try {
      const url = `${baseUrl}report/order/eyewear`;
      const circleCodeValue =
        Array.isArray(activeFilters.circleCode) &&
        activeFilters.circleCode.length > 0
          ? activeFilters.circleCode.join(",")
          : "N";
      const params = {
        state: activeFilters.state,
        circleCode: circleCodeValue,
        fromDate: formatDate(activeFilters.fromDate),
        toDate: formatDate(activeFilters.toDate),
      };

      if (activeFilters.orderId) params.orderId = activeFilters.orderId;
      if (activeFilters.patientId)
        params.patientId = activeFilters.patientId;

      const response = await axios.get(url, { params });
      const data = response?.data?.successList || [];
      setTableData(data);
    } catch (error) {
      console.error("API Error:", error);
      setTableData([]);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  const getDefaultFilters = () => {
    const defaultState =
      loggedInUser?.roleCode !== "PHHEAD"
        ? localStorage.getItem("userState")
        : "OD";

    const circleFromStorage = localStorage.getItem("circleCode");
    const defaultCircleCode = circleFromStorage ? [circleFromStorage] : ["N"];

    return {
      reportType: "EYEWEAR",
      state: defaultState,
      fromDate: formatDateInput(twoDaysAgo),
      toDate: formatDateInput(today),
      orderId: "",
      patientId: "",
      circleCode: defaultCircleCode,
    };
  };

  const handleClearFilters = async () => {
    const nextFilters = getDefaultFilters();
    setFilters(nextFilters);
    setWarehouseDropdownOpen(false);
    await fetchData(nextFilters);
  };

  const handleReportTypeChange = (e) => {
    const selected = e.target.value;
    setFilters((prev) => ({ ...prev, reportType: selected }));

    if (selected === "CHE/Engage") navigate("/orderReport");
    // B2B Partners screens disabled — drop B2B redirect branch.
    // else if (selected === "B2B") navigate("/b2bOrderReport");
    else if (selected === "B2C") navigate("/b2cOrderReport");
    else if (selected === "EYEWEAR") navigate("/eyewearOrderReport");
  };

  const handleSearch = () => {
    fetchData();
  };

  const handleExport = async () => {
    setIsLoading(true);
    try {
        const exportUrl = `${baseUrl}export/download/order/eyewear`;
      const circleCodeValue =
        Array.isArray(filters.circleCode) && filters.circleCode.length > 0
          ? filters.circleCode.join(",")
          : "N";
      const params = new URLSearchParams({
        state: filters.state,
        circleCode: circleCodeValue,
        fromDate: formatDate(filters.fromDate),
        toDate: formatDate(filters.toDate),
      });

      if (filters.orderId) params.append("orderId", filters.orderId);
      if (filters.patientId) params.append("patientId", filters.patientId);

      const response = await axios.get(`${exportUrl}?${params.toString()}`, {
        responseType: "blob",
      });

      const blob = new Blob([response.data], {
        type: "application/vnd.ms-excel",
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `Eyewear_Order_Report_${filters.fromDate}_to_${filters.toDate}.xlsx`;
      link.click();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Export failed", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="p-3 sm:p-6 bg-white rounded-lg">
      <div className="mb-4 text-sm text-gray-500">
        <span className="text-gray-700 font-medium">Reports</span> &gt;{" "}
        <span className="text-blue-600 font-semibold">Eyewear Order Report</span>
      </div>

      <div className="flex flex-wrap items-center gap-3 mb-6">
        <div>
          <select
            className="border px-4 py-2 rounded w-[180px]"
            name="reportType"
            value={filters.reportType}
            onChange={handleReportTypeChange}
          >
            <option value="CHE/Engage">CHE/Engage</option>
            {/* B2B Partners screens disabled — hide B2B source option. */}
            {/* <option value="B2B">B2B</option> */}
            <option value="B2C">B2C</option>
            <option value="EYEWEAR">Eye wear</option>
          </select>
        </div>

        {loggedInUser?.roleCode === "PHHEAD" && (
          <>
            <select
              name="state"
              value={filters.state}
              onChange={handleFilterChange}
              className="border px-3 py-2 w-48 rounded-lg"
            >
              {stateList.map((s) => (
                <option key={s.value} value={s.value}>
                  {s.name}
                </option>
              ))}
            </select>
            {/* <div className="relative w-48" ref={warehouseDropdownRef}>
              <div
                className="flex items-center justify-between border px-3 py-2 rounded-lg cursor-pointer"
                onClick={() => setWarehouseDropdownOpen(!warehouseDropdownOpen)}
              >
                <span className="truncate">
                  {Array.isArray(filters.circleCode) &&
                  filters.circleCode.filter((c) => c !== "N").length > 0
                    ? `${filters.circleCode.filter((c) => c !== "N").length} warehouse(s) selected`
                    : "Select Warehouses"}
                </span>
                <svg
                  className={`w-4 h-4 ml-2 transition-transform ${
                    warehouseDropdownOpen ? "rotate-180" : ""
                  }`}
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M19 9l-7 7-7-7"
                  />
                </svg>
              </div>

              {warehouseDropdownOpen && (
                <div className="absolute z-50 w-full mt-1 bg-white border rounded-lg shadow-lg max-h-60 overflow-y-auto">
                  {warehouseList?.map((warehouse) => {
                    const checked = Array.isArray(filters.circleCode)
                      ? filters.circleCode.includes(warehouse.circleCode)
                      : false;

                    return (
                      <label
                        key={warehouse.pharmacyCode}
                        className="flex items-center px-3 py-2 cursor-pointer hover:bg-gray-100"
                      >
                        <input
                          type="checkbox"
                          checked={checked}
                          onChange={(e) => {
                            let updated = Array.isArray(filters.circleCode)
                              ? [...filters.circleCode]
                              : [];

                            if (e.target.checked) {
                              updated = updated.filter((c) => c !== "N");
                              if (!updated.includes(warehouse.circleCode)) {
                                updated.push(warehouse.circleCode);
                              }
                            } else {
                              updated = updated.filter(
                                (c) => c !== warehouse.circleCode,
                              );
                            }

                            if (updated.length === 0) updated = ["N"];

                            setFilters((prev) => ({
                              ...prev,
                              circleCode: updated,
                            }));
                          }}
                          className="mr-2"
                        />
                        {warehouse.pharmacyName}
                      </label>
                    );
                  })}
                </div>
              )}
            </div> */}
          </>
        )}

        <input
          type="date"
          name="fromDate"
          className="border px-4 py-2 rounded"
          value={filters.fromDate}
          onChange={handleFilterChange}
        />
        <input
          type="date"
          name="toDate"
          className="border px-4 py-2 rounded"
          value={filters.toDate}
          onChange={handleFilterChange}
        />
        <input
          type="text"
          name="orderId"
          className="border px-4 py-2 rounded"
          placeholder="Type Order ID"
          value={filters.orderId}
          onChange={handleFilterChange}
        />
        <input
          type="text"
          name="patientId"
          className="border px-4 py-2 rounded"
          placeholder="Type PatientId"
          value={filters.patientId}
          onChange={handleFilterChange}
        />

        <div>
          <button
            className="flex items-center gap-2 bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-lg shadow-sm transition"
            onClick={handleSearch}
            disabled={isLoading}
          >
            <HiMagnifyingGlass className="h-5 w-5" />
            <span className="text-base font-medium">Search</span>
          </button>
        </div>

        <div>
          <button
            className="flex items-center gap-2 border border-gray-300 text-gray-600 px-4 py-2 rounded-lg shadow-sm hover:bg-gray-100 transition"
            onClick={handleClearFilters}
            disabled={isLoading}
          >
            Clear Filters
          </button>
        </div>

        <div>
          <button
            className="flex items-center gap-2 border border-gray-300 text-gray-600 px-4 py-2 rounded-full shadow-sm hover:bg-gray-100 transition"
            onClick={handleExport}
            disabled={isLoading}
          >
            <HiOutlineArrowUpTray className="h-5 w-4 text-indigo-400" />
            <span className="text-base font-medium">Export Excel</span>
          </button>
        </div>
      </div>

      {isLoading ? (
        <div className="flex justify-center items-center h-64">
          <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
        </div>
      ) : (
        <div className="overflow-x-auto rounded-lg shadow-md">
          <table className="min-w-full border text-sm text-[#1d2f5b] text-semi">
            <thead className="bg-gray-100 text-left">
              <tr>
                {columns.map((column, index) => (
                  <th key={index} className="px-4 py-2 border">
                    {column.header}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {tableData.length > 0 ? (
                tableData.map((row, index) => (
                  <tr key={index} className="even:bg-gray-50">
                    {columns.map((column, colIndex) => {
                      let cellValue = row[column.field] ?? "-";

                      if (column.field === "billingDate") {
                        cellValue = row[column.field]
                          ? fixMonthDisplay(
                              row[column.field],
                              "MM/DD/YYYY hh:mm:ss",
                            )
                          : "-";
                      }

                      return (
                        <td
                          key={colIndex}
                          className="px-4 py-2 text-gray-700"
                          title={typeof cellValue === "string" ? cellValue : ""}
                        >
                          {cellValue}
                        </td>
                      );
                    })}
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan={columns.length}
                    className="px-4 py-6 text-center text-gray-500"
                  >
                    No data found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default EyewearOrderReports;

